import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import sectionImage from '../assets/Images/conference.jpg';

const BackgroundWrapper = styled(Box)(() => ({
  position: 'relative',
  width: '100%',
  minHeight: '100vh',
  background: `url(${sectionImage}) center/cover no-repeat`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

const Overlay = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
}));

const WhiteSection = styled(Box)(() => ({
  position: 'relative',
  width: '100%', 
  maxWidth: '1300px', 
  backgroundColor: 'white',
  padding: '40px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
}));

const awards = [
  {
    title: 'Best Postgraduate Research Award',
    description:
      'Awarded to the most outstanding research contribution in the postgraduate category.',
  },
  {
    title: 'Best Undergraduate Research Award',
    description:
      'Awarded to the most outstanding research contribution in the undergraduate category.',
  },
  {
    title: 'Best Paper Presentation Awards',
    description:
      'Awarded to the most outstanding paper presentations across each full paper track.',
  },
];

const AwardsSection = () => {
  return (
    <BackgroundWrapper id = 'awards'>
      <Overlay />

      {/* Conference Awards Title */}
      <Typography
        variant='h4'
        gutterBottom
        fontSize={{ xs: '2.0rem', sm: '2.5rem', md: '3.5rem' }}
        marginTop='100px'
        fontWeight='bold'
        sx={{ color: 'white', zIndex: 1, textAlign: 'center' }}
        width='100%'
      >
        Conference Awards
      </Typography>

      {/* White Info Section with Responsive Padding */}
      <WhiteSection
        sx={{ zIndex: 1, px: { xs: 2, md: 8 }, marginTop: '100px' }}
      >
        <Typography
          variant='h5'
          fontWeight='bold'
          fontSize={{ xs: '1.5rem', sm: '1.8rem', md: '2rem' }}
          gutterBottom
          color='black'
          sx={{
            paddingLeft: { xs: '16px', sm: '24px', md: '32px' },
            paddingRight: { xs: '16px', sm: '24px', md: '32px' },
          }}
        >
          Presentation Awards of the{' '}
          <span style={{ color: 'red' }}>ADScAI 2026</span>
        </Typography>

        <Typography
          color='black'
          alignContent='center'
          maxWidth='1100px'
          variant='body1'
          paragraph
          fontSize={{ xs: '0.875rem', sm: '1rem', md: '1.1rem' }}
          sx={{
            paddingLeft: { xs: '16px', sm: '24px', md: '32px' },
            paddingRight: { xs: '16px', sm: '24px', md: '32px' },
          }}
        >
          Presentation awards are given with the intention of recognizing one’s
          contribution to the field and encouraging more active participation
          for the betterment of the research fraternity as a whole. The concept
          will inspire you to achieve more and may lead to policy implementation
          in the pursuit of a fruitful tomorrow.
        </Typography>

        <Typography
          color='black'
          maxWidth='1100px'
          variant='body1'
          fontSize={{ xs: '0.875rem', sm: '1rem', md: '1.1rem' }}
          sx={{
            paddingLeft: { xs: '16px', sm: '24px', md: '32px' },
            paddingRight: { xs: '16px', sm: '24px', md: '32px' },
          }}
        >
          The final decisions will be taken by the evaluation panel members of
          the session and the Conference Chair. The panel will consist of
          experts with strong academic or industrial backgrounds in the subject
          area. The highest scoring presentations will be recommended for the
          awards based on the evaluation committee’s and the Conference Chair’s
          rankings.
        </Typography>
      </WhiteSection>

      {/* Presentation Awards Categories Title */}
      <Typography
        variant='h4'
        fontWeight='bold'
        gutterBottom
        sx={{
          color: 'white',
          zIndex: 1,
          textAlign: 'center',
          mt: 4,
          paddingLeft: { xs: '16px', sm: '24px', md: '32px' },
          paddingRight: { xs: '16px', sm: '24px', md: '32px' },
        }}
        width='100%'
        fontSize={{ xs: '1.5rem', sm: '2rem', md: '2.5rem' }}
      >
        Presentation Awards Categories
      </Typography>

      {/* Awards Description */}
      <Typography
        variant='body1'
        gutterBottom
        sx={{
          color: 'white',
          zIndex: 1,
          textAlign: 'center',
          paddingLeft: { xs: '16px', sm: '24px', md: '32px' },
          paddingRight: { xs: '16px', sm: '24px', md: '32px' },
        }}
      >
        The awards are given to the most outstanding researchers of the
        conference under four categories.
      </Typography>

      {/* Awards Cards */}
      <Grid
        container
        spacing={3}
        justifyContent='center'
        alignItems='center'
        marginBottom='100px'
        sx={{ mt: 2, zIndex: 1, px: 2 }}
      >
        {awards.map((award, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <Card
              sx={{
                backgroundColor: 'white',
                borderBottom: '4px solid red',
                borderRadius: 2,
                boxShadow: 3,
                maxWidth: 550,
                width: '100%',
                padding: 3,
                textAlign: 'center',
              }}
            >
              <CardContent>
                <Typography variant='h6' fontWeight='bold'>
                  {award.title}
                </Typography>
                <Typography variant='body2' color='textSecondary'>
                  {award.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </BackgroundWrapper>
  );
};

export default AwardsSection;
